
import { createSlice } from '@reduxjs/toolkit';
import { AppState } from '../../app/store';
import { LogEntry } from './logEntry';
import { TripType } from './tripType';

export type LogMode = 'miles' | 'points'

export type LogState = {
  mode: LogMode;
  entries: LogEntry[];
};

export const logSlice = createSlice({
  name: 'log',
  initialState: {
    mode: 'miles',
    entries: []
  } as LogState,
  reducers: {
    setMode: (state, action: { payload: LogMode }) => {
      state.mode = action.payload;
    },
    addTrip: (state, action: { payload: LogEntry}) => {
      state.entries.push(new LogEntry(action.payload));
    },
    removeTrip: (state, action: { payload: number }) => {
      state.entries.splice(action.payload, 1);
    },
  },
});

export const { addTrip, removeTrip, setMode } = logSlice.actions;

// TODO – work in Caitlyn's points system, and then include it in Add Log Entry menu
export const points = (quantity: number, unit : TripType) => {
  switch(unit) {
    default:
      return quantity;
  }
}

export const sumEntries = (entries : LogEntry[]) =>  entries
  .map(entry => points(entry.distance, entry.type))
  .reduce((acc, cur) => acc + cur, 0);

// Selectors
export const selectLog = (state : { log: LogState }) => state.log;

export const selectMode = (state: { log: LogState }) => state.log.mode;

export const selectSum = (state : { log: LogState }) => sumEntries(state.log.entries);

export const selectAvailableVideos = (state : AppState) => {
  const sum = sumEntries(state.log.entries);
  return (state.content.content.data || []).filter(content => content.unlocked_after <= sum);
}

export const selectNextVideo = (state : AppState) => {
  const sum = sumEntries(state.log.entries),
    unlocked = (state.content.content.data || []).filter(content => content.unlocked_after <= sum);
  console.log('(selectNextVideo)', unlocked);
  return unlocked[unlocked.length - 1];
}

export default logSlice.reducer;